import { UserLogin, ConfirmMail, UiModal, AgeConfirmation } from "libs/raas-ui-react-components/src/components"
import { useState } from "react"
import { useNavigate } from "react-router-dom";
import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { getDeviceKey, setStorage } from "services/user/user.session.service";

import useSession from "hooks/useSession";
import useToast from "hooks/useToast";
import { openMail } from "../RegistroUser/RegisterUser.service";
import { useTranslation } from "react-i18next";
import { getLiteralsConfirmMailPage, getLiteralsUserPage } from "./LoginFlow.util";
import { getPromiseByProvider } from "services/user/user-login-social.service";

declare const window: any;
export const LoginFlow = () => {


  const [t, i18n] = useTranslation("login");
  const { openToast } = useToast();
  const navigate = useNavigate();
  const { setSession, setLogged } = useSession();
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState('');
  const [password, setPass] = useState('');
  const [loginToken, setLoginToken] = useState();

  /**** Literales por pagina ****/
  const literalsUserPage = getLiteralsUserPage(t);
  const literalsConfirmMailPage = getLiteralsConfirmMailPage(t);
  
  /* Control edad 16 */
  const [tGlobal] = useTranslation("global");
  const [confirmationAge, setConfirmationAge] = useState(false);


  const handleNextPage = (data: any) => {
    setEmail(data?.detail?.email);
    setPass(data?.detail?.pass);
    let loginBody = {
      username: data?.detail?.email,
      password: data?.detail?.pass,
      deviceKey: getDeviceKey()
    }
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
          openToast("success", t('literal.emailSent'), t('literal.findYourCodeIn') + t('literal.yourEmail') + data?.detail?.email)
          setStep(1);
        } else {
          okLogin(response?.data);
        }
      }).catch(() => {
        let literal = t('literal.anErrorOccurred');
        openToast("error", t('literal.error'), literal);
        window.dataLayer?.push({
          event:"screen_view",
          screen_name:"email",
          screen_class:"error_login"
        });
      })
  }

  const okLogin = (data: any) => {

    setSession(data);
    setStorage(data);
    setLogged(true);
    navigate("/plan");
    window.dataLayer?.push({
      event:"login",
      method:"email"

    });
  }

  const hadleVerifyMail = (data: any) => {
    const code = data?.detail;
    let verifyBody = {
      token: loginToken,
      email,
      code
    }
    postAxios(apiNames.IDENTITY, false, "/sessions/verification-code", verifyBody)
      .then((response: any) => {
        if (response?.status == 206) {
          setLoginToken(response?.data?.token);
          openToast("error", t('literal.error'), t('literal.incorrectCode'));
        } else {
          okLogin(response?.data);
        }
      }).catch((error: any) => {
        if (error?.status === 400) {
          if(error?.data?.errors?.[0]?.message === 'User under 16 years old'){
            setConfirmationAge(true);
          } else {
            openToast("error", t('literal.error'), t('literal.incorrectCode'));
          }
        } else if (error.status === 401) {
          openToast("error", t('literal.error'), t('literal.wrongEmailOrPassword'));
          setStep(0);
        }
      })
  }

  const handleExit = () => {
    navigate(-1);
  }
  const handleBack = () => {
    navigate("/home");
  }

  const handleNewPass = () => {
    navigate("/reset-password");
  }

  const handleOpenMail = () => {
    openMail(email);
  }

  const handleReSendEmail = () => {
    // resendMail(email, openToast)
    openToast("success", t('literal.emailSent'), t('literal.findYourCodeIn') + t('literal.yourEmail') + email);
    let loginBody = {
      username: email,
      password: password,
      deviceKey: getDeviceKey()
    }
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
          setStep(1);
        } else {
          okLogin(response?.data);
        }
      }).catch(() => {
        let literal = t('literal.anErrorOccurred');
        openToast("error", "Error", literal);
      })
  }

  const handleLoginSocial = ({ detail }: CustomEvent) => {
    window.dataLayer?.push({
      event: "select_content",
      screen_name: 'welcome',
      screen_class: 'onboarding',
      content_name: 'social_login',
      content_type: detail,
    });
    getPromiseByProvider(detail);
  }

  const getComponent = (currentStep: number) => {
    switch (currentStep) {
      case 0:
        return <UserLogin
          literals={literalsUserPage}
          onNextPage={handleNextPage}
          onNewPass={handleNewPass}
          onExitPage={handleExit}
          onBackPage={handleBack}
          onLoginSocialClicked={handleLoginSocial}
        />
      case 1:
        return <ConfirmMail
          literals={literalsConfirmMailPage}
          mail={email}
          onResendMail={handleReSendEmail}
          onOpenMail={handleOpenMail}
          onVerifyEmail={hadleVerifyMail}
          onBackPage={() => setStep(0)}
          onExitPage={handleExit} />
    }
  }

  return (
    <>
      {getComponent(step)}
      <UiModal open={confirmationAge} blockOverlay={true}>
        <AgeConfirmation
          literals={{
            title: tGlobal("age-confirmation.title"),
            description: tGlobal("age-confirmation.description"),
            buttonText: tGlobal("age-confirmation.buttonText"),
            confirmationButton: tGlobal("age-confirmation.confirmationButton"),
            secondaryButtonText: tGlobal("age-confirmation.secondaryButtonText"),
          }}
          confirmation={true}
          onUnderstood={() =>{
            setConfirmationAge(false)
            navigate('/');
          }}
        />
      </UiModal>
    </>
  )
}
